import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "タイトル",
  value = "",
  helperText = "",
  readonly = false,
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfTitle"
    label={label}
    value={value}
    size="small"
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
    fullWidth
    inputProps={{ readOnly: readonly }}
  />
);

export default FromTextField;